import jump from 'jump.js';
import $ from 'jquery';

function linkify(text, type) {
	text = text.replace(
		/((https?\:\/\/)|(www\.))(\S+)(\w{2,4})(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/gi,
		function(url){
			var full_url = !url.match('^https?:\/\/') ? 'http://' + url : url ;
			return '<a target="_blank" href="' + full_url + '">' + url + '</a>';
		}
	);
	if(type == 'twitter'){
		text = text.replace(/(^|\s)@(\w+)/g, '$1<a rel="noopener noreferrer" target="_blank" title="Go to $2s twitter profile" href="http://www.twitter.com/$2">@$2</a>');
		text = text.replace(/(^|\s)#(\w+)/g, '$1<a rel="noopener noreferrer" target="_blank" title="View similar hashtags to $2" href="http://twitter.com/search/%23$2">#$2</a>');
	} else if(type == 'facebook'){
		text = text.replace(/(^|\s)#(\w+)/g, '$1<a rel="noopener noreferrer" target="_blank" title="View similar hashtags to $2" href="http://facebook.com/hashtag/%23$2">#$2</a>');
	}
	return text;
}

function jumplinks(element_id) {
	$(element_id).find('a[href*="#"]').each((item, element) => {
		$(element).on('click', function(event) {
			const scroolToElement = $(this);

			if (scroolToElement[0].pathname === location.pathname) {
				event.preventDefault();

				jump(scroolToElement[0].hash);

				$('#mobile_menu_toggle').removeClass('is-active');
				$('#mobile_menu_overlay').addClass('off');
				$('#mobile_menu_generated').addClass('off');
			}
		});
	});
}

function parseItems(items) {
	var itemArray = new Array();
	$.each(items, function (i, item) {
		itemArray.push(parseItem(item));
	});
	return JSON.parse(JSON.stringify(itemArray));
}

function parseItem(item) {
	var json_arr = {};
	$.each(item.Properties.$values, function (i, node) {
		var val = node.Value;
		if (typeof val === "object") val = val.$value;
		json_arr[node.Name] = val;
	});
	return JSON.parse(JSON.stringify(json_arr));
}

export { linkify, jumplinks, parseItems, parseItem };



// WEBPACK FOOTER //
// ./theme_components/js/modules/_utilities.js